import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EliminarEntidadComponent } from '../../../helpers/components/deleteEntity/deleteEntity.component';
import { PaymentGatewayModel } from 'app/infrastructure/model/interfaces/paymentGateway.interface';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-home-payment',
  templateUrl: './home.payment.component.html',
  styleUrls: ['./home.payment.component.css']
})
export class HomePaymentComponent implements OnInit {

  @Input() payment: PaymentGatewayModel;
  @Input() codSistema: String;
  @Input() esNuevo: boolean;
  @Input() checkeandCodigo: boolean;
  @Input() errorCodigo: string;
  @Input() completitud: number;

  @Output() edited: EventEmitter<PaymentGatewayModel> = new EventEmitter();
  @Output() create: EventEmitter<PaymentGatewayModel> = new EventEmitter();
  @Output() deleted: EventEmitter<any> = new EventEmitter();

  pgCode: String;

  constructor(private sxTranslationService: SxTranslationService, 
    private modalService: NgbModal,
    private srvpayment: PaymentGatewayService, 
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.pgCode = this.payment.pgCode;
  }

  edit() {
    this.edited.emit(this.payment);
  }

  editDescription(event) {
    this.payment.description = event;
    this.edited.emit(this.payment);
  }

  confirmPayment() {
    this.create.emit(this.payment);
  }

  //it wont work unless I call it like this. I HAVE NO CLUE WHY! o_o
  delete() {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);

    const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
    const text = this.sxTranslationService.getResource('DISABLE_TEXT');
    modalInstance.titulo = `${text} ${this.payment.pgCode}?`;

    modalRef.result
      .then(confirmacion => {
        this.srvpayment.delete(this.payment.systemCode,this.payment.pgCode).subscribe(ok => this.back());
      },
        reason => { /* Do nothing */ }
      );
  }

  configuration() {
    this.router.navigate(['confPayment'], { relativeTo: this.route });
  }
  back() {
    const isNew = this.esNuevo;//this.route.snapshot.params.new;
    let navigation = ['..'];
    if (!isNew) {
      navigation = ['../../'];
    }
    this.router.navigate(navigation, { relativeTo: this.route.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/paymentGateways/home/home.payment.component.ts